import type { Application } from '@memed/x-ray-tracker-js';
import XRayTracker from '@memed/x-ray-tracker-js';
import { DispensationProperties } from '@memed/x-ray-tracker-js/types/context';
import { PermissionsInterface } from '../interfaces/drugstore';
import { UserInterface } from '../interfaces/user';

interface UserTrackerData {
  id: string;
  userType: 'pharmacist';
}


let environment = 'development';
const firstDomain = document.location.host.replace('www.', '').split('.')[0];

if (firstDomain === 'memed' || firstDomain === 'beta') {
  environment = 'production';
}
const xRayTracker = (() => {
  try {
    return new XRayTracker(environment);
  } catch {
    
    return undefined;
  }
})();

export const initializeTracker = async (userParam: UserInterface, 
  permissions: PermissionsInterface): Promise<boolean> => {


  if (typeof xRayTracker === 'undefined') {
    return false;
  }

  try {
    const app: Application = {
      version: process.env.REACT_APP_VERSION || 'unknown',
      name: 'Módulo de Dispensação',
      build: '1.0.0',
      namespace: 'aplicacoes.dispenser',
    };

    xRayTracker.setMode('LIVE');

    const [, user] = await Promise.all([xRayTracker.load(app), userParam]);

    const userTrackerData: UserTrackerData = {
      id: String(user.id),
      userType: 'pharmacist',
    };

    trackDispensationTokenPageView(permissions)

    return await xRayTracker.identify(userTrackerData);
  } catch {
    return false;
  }
};

const handleError = (error: unknown): void => {
  const message = (error instanceof Error && error.message) || error || 'desconhecido';

  // eslint-disable-next-line no-console
  console.error(new Error(`[XRay] Não foi possível enviar evento\n Motivo: ${message}`));
};

const trackEvent = (
  eventName: string,
  pageName: string,
  properties?: DispensationProperties,
): boolean => {
  if (typeof xRayTracker === 'undefined') {
    return false;
  }

  try {
    return xRayTracker.event(eventName, pageName, properties);
  } catch (error) {
    handleError(error);

    return false;
  }
};

interface IBannerTrackerEvent {
  drugstore_id?: number;
  drugstore_name: string;
  drugstore_uf?: string;
  chain_id?: number;
  chain_name?: string;
  banner_campaign_name: string;
  banner_content: {
    id: string;
    creative: string;
  }
}

export const trackBanner = (
  eventName: string,
  properties: IBannerTrackerEvent,
): void => {
  trackEvent(eventName, 'dispensation_token_insert', properties);
};

export const trackDispensationTokenPageView = (permissions: PermissionsInterface): void =>
{
  const properties: DispensationProperties = {
    
    drugstore_id: permissions.current_drugstore?.id,
    drugstore_uf: permissions.current_drugstore?.uf,
    drugstore_name: permissions.user.name,
    chain_id: permissions.current_drugstore?.chain.id,
    chain_name: permissions.current_drugstore?.chain.name
  }

  trackEvent('Dispensation Token Insert Pageview', 'dispensation_token_insert', properties);
}




